import React from "react";
import { Link } from "react-router-dom";
import { logoutUser } from "../../actions/authActions";
import { useAlert } from "react-alert";
import { useDispatch, useSelector } from "react-redux";
import { localAssetUrl } from "../../utils/assets";

const DashHeader = () => {
  const alert = useAlert();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const userInitials =
    `${user?.first_name?.trim()?.[0] || ""}${user?.last_name?.trim()?.[0] || ""}`.toUpperCase() ||
    "ST";

  const logoutHandler = () => {
    dispatch(logoutUser());
    alert.success("Logout successfully.");
  };

  return (
    <header className="student-topbar">
      <div className="student-topbar__user">
        <div className="student-topbar__avatar">
          {user?.profileImage ? (
            <img src={localAssetUrl(`assets/img/${user.profileImage}`)} alt="" />
          ) : (
            <span>{userInitials}</span>
          )}
        </div>
        <div>
          <p className="student-topbar__kicker">Welcome back,</p>
          <p className="student-topbar__name">
            {user?.first_name} {user?.last_name}
          </p>
        </div>
      </div>

      <div className="student-topbar__actions">
        <Link to="/" className="student-topbar__action">
          <i className="fas fa-home" aria-hidden="true" /> Home
        </Link>
        <Link to="/login" className="student-topbar__action" onClick={logoutHandler}>
          <i className="fas fa-sign-out-alt" aria-hidden="true" /> Log Out
        </Link>
      </div>
    </header>
  );
};

export default DashHeader;
